import styled from 'styled-components';
import { Colors, Media } from 'enums';

type ICardBar = {
  cardBarBgColor?: string;
};

export const CardBar = styled.div<ICardBar>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  height: 83px;
  padding: 8px 14px;
  p {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  background-color: ${({ cardBarBgColor }) => {
    if (cardBarBgColor) {
      return cardBarBgColor;
    }
    return `${Colors.card}`;
  }};
  border-radius: 0 0 10px 10px;

  @media ${Media.notebook} {
    height: 90px;
  }
`;

export const CardHeader = styled.div`
  margin-bottom: 6px;
  margin-right: 10px;
`;

export const CardBarSection = styled.div`
  max-width: 300px;
`;

export const DiscountTextWrapper = styled.div`
  white-space: nowrap;
  overflow: visible; /* Ensure content is not clipped */
`;
